import { CloudStore } from "@omni/types/api/store/cloud/store.model";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

const useStoreFullName = (store?: CloudStore | null) => {
    const { t } = useGranite();

    return store?.shopName ? t("general.shopName", store?.shopName) : undefined;
};

export { useStoreFullName };
